import { combineReducers } from 'redux';
import Auth from './auth/reducers';
import Loan from './loan/reducers';
import Property from './property/reducers';
import Security from './security/reducers';
import Lenders from './lender/reducers';
import UserManagement from './userManagement/reducers';
import notifications from './notifications/reducers';
import dispatchAdminUpdate from './AdminUpdatePushButton/reducers';
import reports from './reports/reducers';
import hubspotAPI from './hubspot_API/reducers';
import ArcherChatReducer from './archerChat/reducer';


export default combineReducers({
    Auth,
    Loan,
    Property,
    Lenders,
    Security,
    //User Management
    UserManagement,
    //Notifications
    notifications,
    //Admin Update Push Button
    dispatchAdminUpdate,
    //Reports Dashboard
    reports,
    hubspotAPI,
    ArcherChat: ArcherChatReducer,

});

//All redux reducer functions need to be added to this page to be imported into the respective class 
// and define the state of the const 
// called in the store.js
